import { useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useSignIn } from 'react-auth-kit';
import './Login.css';
import axios from 'axios';
import { useHistory } from "react-router-dom";
import Alert from 'react-bootstrap/Alert'

const Login = ({ onLogin }) => {

const [alertMessage, setAlertMessage] = useState('');
  const signIn = useSignIn();
  const history = useHistory();
  const handleSubmit = async (values) => {

    let response;

    try {
        response = await axios.post(
          process.env.REACT_APP_BACKEND_HOST+'/api/v1/auth/login', 
          values,
          {
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json'
            },
          })
    }catch(err) {
        console.log(err);
        setAlertMessage({ variant: 'danger', message: err.message});
        throw new Error(err.message); 
    }

    console.log('Login response', response)

    if (response.status === 200) {
        console.log('Login token', response.data.token)
      signIn({ 
          token: response.data.token, 
          expiresIn: 3600 , 
          tokenType: 'Bearer',
          authState: {email: values.email}
        });

        onLogin();
        history.push("/");
    
    } else {
      const data = await response.json();
      console.error(data.error);
    }
  };

  return (

    <div className="login-container">

      {/* <h1>Login</h1> */}
      {alertMessage && (
			<>
				<Alert variant={alertMessage.variant}>{alertMessage.message}</Alert>
				<div>
				<button className="close-button" type="button" onClick={() => setAlertMessage(false)}>X</button>
				</div>
			</>
		    )}
      <Formik
        initialValues={{ email: '', password: '' }}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = 'Required';
          } else if (!/\S+@\S+\.\S+/.test(values.email)) {
            errors.email = 'Invalid email address';
          }
          if (!values.password) {
            errors.password = 'Required';
          }
          return errors;
        }}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <Field type="email" name="email" className="form-control" />
              <ErrorMessage name="email" component="div" className="invalid-feedback" />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <Field type="password" name="password" className="form-control" />
              <ErrorMessage name="password" component="div" className="invalid-feedback" />
            </div>
            <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
              Submit
            </button>
          </Form>
        )}
      </Formik>
    </div>

  );
};

export default Login;